// extracted by mini-css-extract-plugin
export default {"widgetContainer":"widgetContainer--hx6tA","trustPilotWidget":"trustPilotWidget--hx6tA"};